import React, { ReactNode } from 'react';
interface ActionButtonProps {
  children: ReactNode;
  href: string;
  variant?: 'primary' | 'ghost';
  className?: string;
  external?: boolean;
}
const base = 'group relative inline-flex items-center justify-center overflow-hidden rounded-sm px-8 py-4 font-mono text-[10.5px] uppercase tracking-[0.22em] transition-colors duration-500 focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-brass focus-visible:ring-offset-2 focus-visible:ring-offset-ink';
const variants: Record<'primary' | 'ghost', string> = {
  primary: 'bg-brass text-[#1a1208] hover:bg-cream',
  ghost: 'border border-cream/30 text-cream hover:border-brass hover:text-brass backdrop-blur-sm'
};
export function ActionButton({
  children,
  href,
  variant = 'primary',
  className = '',
  external = false
}: ActionButtonProps) {
  return <a href={href} className={`${base} ${variants[variant]} ${className}`} {...external ? {
    target: '_blank',
    rel: 'noreferrer'
  } : {}} data-id="element-11" data-mp="au33stg0jyt8">
      <span className="relative z-10" data-id="element-12" data-mp="2645u85u9d07b">{children}</span>
      <span aria-hidden="true" className="absolute inset-0 -translate-x-full bg-gradient-to-r from-transparent via-white/25 to-transparent transition-transform duration-[1100ms] ease-out group-hover:translate-x-full" data-id="element-13" data-mp="265qkhj9jhwzd" />
    </a>;
}